import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSemicolon',
  pure: true,
  standalone: true,
})
export class FormatSemicolonPipe implements PipeTransform {
  transform(to: string | null | undefined): string {
    if (!to) {
      return '';
    }
    return to.split(';').join('; ');
  }
}
